import forEach from "lodash/forEach";
export const processAppliedUpdates = (appliedUpdates) => {
    const appliedSourceTaskIds = new Set();
    const appliedUpdatesNodesSource = {};
    const appliedUpdatesEdgesSource = {};
    if (appliedUpdates) {
        forEach(appliedUpdates.NodesSource, n => {
            appliedUpdatesNodesSource[n.NodeId] = n;
            if (n.SourceTaskId) {
                appliedSourceTaskIds.add(n.SourceTaskId);
            }
        });
        forEach(appliedUpdates.EdgesSource, e => {
            appliedUpdatesEdgesSource[e.EdgeId] = e;
            if (e.SourceTaskId) {
                appliedSourceTaskIds.add(e.SourceTaskId);
            }
        });
    }
    return {
        appliedSourceTaskIds,
        appliedUpdatesNodesSource,
        appliedUpdatesEdgesSource
    };
};
